<script setup lang="ts">
import FlatButton from '@/components/atoms/FlatButton.vue'
import { REPLACE_NAME_VARIABLES } from '@/libs/utilities/replaceVariable'

defineProps<{
  message: string
  selections: string[]
  maybeOtherUserNames: string[]
}>()

const emit = defineEmits<{
  close: []
  confirm: []
}>()
</script>

<template>
  <div :class="$style.wrapper">
    <p :class="$style.title">この内容で送信しますか？</p>
    <div :class="$style.caution">
      <p :class="$style.caution__text">
        別のユーザーの名前が記入されている可能性があります。<br />
        {{
          REPLACE_NAME_VARIABLES.name
        }}と記述すると自動でユーザー名に変換されます。
      </p>
      <ul :class="$style.caution__list">
        <li
          :class="$style.listItem"
          v-for="(name, index) in maybeOtherUserNames"
          :key="index"
        >
          {{ name }}
        </li>
      </ul>
    </div>
    <p>
      メッセージ送信の取り消しはできません。<br />
      この内容で送信しますか？
    </p>

    <div :class="$style.preview">
      <p>{{ message }}</p>
      <ul>
        <li
          :class="$style.listItem"
          v-for="(selection, index) in selections"
          :key="index"
        >
          {{ selection }}
        </li>
      </ul>
    </div>

    <section :class="$style.buttonSection">
      <FlatButton @click="emit('confirm')">この内容で送信する</FlatButton>
      <FlatButton variant="secondary" @click="emit('close')"
        >修正する</FlatButton
      >
    </section>
  </div>
</template>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px 28px;
  align-items: center;
}

.title {
  font-size: 20px;
  font-weight: 700;
}

.listItem {
  list-style: disc inside;
}

.caution {
  color: $color-caution-accent;

  &__text {
    font-weight: 700;
  }

  &__list {
    &:nth-child(n + 2) {
      margin-top: 16px;
    }
  }
}

.preview {
  width: 100%;
  padding: 16px;
  background-color: $color-surface-secondary;
  border-radius: $border-radius-v2-base;
}

.buttonSection {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
}
</style>
